import { render } from "./ProgramMetricReport.vue?vue&type=template&id=2d157cc3&ts=true"
import script from "./ProgramMetricReport.vue?vue&type=script&lang=ts"
export * from "./ProgramMetricReport.vue?vue&type=script&lang=ts"

import "./ProgramMetricReport.vue?vue&type=style&index=0&id=2d157cc3&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__